/**
 * This function's arguments are loosely typed because the type checking should
 * be done by other code.
 */
export function formatPathParams(
	pathPattern: string,
	params: Record<string, unknown> | undefined
) {
	return pathPattern.replaceAll(/:[^&/.-]+/gu, (match) => {
		const paramName = match.slice(1);
		if (params === undefined || !(paramName in params)) {
			console.error('Missing path parameter:', paramName);
			return 'null';
		}
		const paramValue = params[paramName];
		return encodeURIComponent(String(paramValue));
	});
}
